import { SpdrClientViewModel } from "../../../ViewModel/SpdrClientViewModel";
import { PdsrClientViewModel } from "../../../ViewModel/PdsrClientViewModel";
import { isSpdr } from "./IsSpdr";
import SpdrText from "./SpdrText";
import { isPdsr } from "./IsPdsr";
import PdsrText from "./PdsrText";

type Props = {
  spdrOrPdsr: SpdrClientViewModel | PdsrClientViewModel;
};

export default function SpdrOrPdsrText({ spdrOrPdsr }: Props) {
  const { SupplierGsdb, PlantGsdb, DockCode } = spdrOrPdsr;
  if (isSpdr(spdrOrPdsr)) {
    return <SpdrText SupplierGsdb={SupplierGsdb} PlantGsdb={PlantGsdb} DockCode={DockCode} />;
  }

  if (isPdsr(spdrOrPdsr)) {
    const { ContainerNetwork } = spdrOrPdsr as PdsrClientViewModel;
    return (
      <PdsrText
        ContainerNetwork={ContainerNetwork}
        PlantGsdb={PlantGsdb}
        DockCode={DockCode}
        SupplierGsdb={SupplierGsdb}
      />
    );
  }

  throw Error(`Component not implemented for ${spdrOrPdsr}`);
}
